import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import {
  Home,
  AllJobRequests,
  AppManagement,
  Roles,
  AllCustomers,
  AllArtisans,
  AllQuotations,
  Quotation,
  AllReceipts,
  Assessment,
  AssessmentPage,
  Notfound,
  AllClaims,
} from './pages';
import { ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import theme from './theme';
import Dashboard from './pages/Dashboard';
import { AuthProvider } from './context/useAuth';
import { Protected } from './components';
import { DashboardCard } from './components';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route
                path="dashboard"
                element={
                  <Protected redirectPath="/">
                    <Dashboard />
                  </Protected>
                }
              >
                <Route
                  path="job-requests"
                  element={
                    <Protected redirectPath="/">
                      <AllJobRequests />
                    </Protected>
                  }
                />

                <Route
                  index
                  element={
                    <Protected redirectPath="/">
                      <DashboardCard />
                    </Protected>
                  }
                />
                <Route
                  path="all-customers"
                  element={
                    <Protected redirectPath="/">
                      <AllCustomers />
                    </Protected>
                  }
                />
                <Route
                  path="artisans"
                  element={
                    <Protected redirectPath="/">
                      <AllArtisans />
                    </Protected>
                  }
                />
                <Route
                  path="quotations"
                  element={
                    <Protected redirectPath="/">
                      <AllQuotations />
                    </Protected>
                  }
                />
                <Route
                  path="quotations/:id"
                  element={
                    <Protected redirectPath="/">
                      <Quotation />
                    </Protected>
                  }
                />
                <Route
                  path="receipt"
                  element={
                    <Protected redirectPath="/">
                      <AllReceipts />
                    </Protected>
                  }
                />
                <Route
                  path="app-management"
                  element={
                    <Protected redirectPath="/">
                      <AppManagement />
                    </Protected>
                  }
                />
                <Route
                  path="assessments"
                  element={
                    <Protected redirectPath="/">
                      <AssessmentPage />
                    </Protected>
                  }
                />
                <Route
                  path="assessments/:id"
                  element={
                    <Protected redirectPath="/">
                      <Assessment />
                    </Protected>
                  }
                />
                <Route
                  path="roles-functions"
                  element={
                    <Protected redirectPath="/">
                      <Roles />
                    </Protected>
                  }
                />
                <Route
                  path="assessments"
                  element={<Protected redirectPath="/"></Protected>}
                />
                <Route
                  path="claims"
                  element={
                    <Protected redirectPath="/">
                      <AllClaims />
                    </Protected>
                  }
                />
              </Route>

              {/* <Route
                  path="profile"
                  element={
                    <Protected redirectPath="/">
                      <Profile />
                    </Protected>
                  }
                />
              </Route>
              <Route path="/verification" element={<VerifyPhone />} />
              <Route path="/verify-otp" element={<VerifyOTP />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              */}
              <Route path="*" exact element={<Notfound />} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </LocalizationProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
